import { ICacheContext } from 'framework/context/ICacheContext';
import { IInventoryItemTaxonomies } from 'gen/ApiClient';
import React from 'react';

export const TaxonomiesCacheContext = React.createContext<ICacheContext<IInventoryItemTaxonomies>>(undefined as any);